const ADMIN_RETURN_KEY = "ofuesi_admin_return_path";

const ADMIN_TAB_PATHS = new Set([
  "dashboard",
  "members",
  "activities",
  "regions",
  "kit",
  "messages",
  "gallery",
  "gallery-settings",
  "chats",
  "prayers",
  "prayer-letter",
  "registrations",
  "badges",
  "conf-analytics",
  "checkin",
  "cancellations",
  "conference-content",
  "conference-kit",
  "notices",
  "audit",
  "settings",
]);

export const getAdminTabPath = (tab: string) => `/admin/dashboard/${tab}`;

export const getSafeAdminReturnPath = (fallback = "/admin/dashboard/dashboard") => {
  try {
    const stored = localStorage.getItem(ADMIN_RETURN_KEY) || "";
    if (isValidAdminReturnPath(stored)) return stored;
  } catch (error) {
    console.warn("[admin-route] Could not read saved admin route", error);
  }
  return fallback;
};

export const rememberAdminReturnPath = (path: string) => {
  if (!isValidAdminReturnPath(path)) {
    console.warn("[admin-route] Ignoring invalid admin route", { path });
    return;
  }
  try {
    localStorage.setItem(ADMIN_RETURN_KEY, path);
  } catch (error) {
    console.warn("[admin-route] Could not save admin route", error);
  }
};

export const isValidAdminReturnPath = (path: string) => {
  if (!path || !path.startsWith("/admin/dashboard")) return false;
  const url = new URL(path, window.location.origin);
  const [, first, second, tab] = url.pathname.split("/");
  if (first !== "admin" || second !== "dashboard") return false;
  return !tab || ADMIN_TAB_PATHS.has(tab);
};